import React from 'react';
import { Link } from 'react-router-dom';
import GLOBALS from '../config/globals';
import { getSeriesAndRound, getPlayoffTrophyTier } from '../helpers/playoffHelpers';

const PlayoffPromoCard = ({ run }) => {
    const isChampion = run?.status === GLOBALS.PLAYOFF_STATUS.CHAMPION;
    const isEliminated = run?.status === GLOBALS.PLAYOFF_STATUS.ELIMINATED;
    const trophyInfo = isEliminated ? getPlayoffTrophyTier(run.currentRound, run.status) : null;

    return (
        <div className={`priority-card ${isChampion ? 'accent-green' : 'accent-orange'}`}>
            <div className="priority-card-header">
                <h3>Daily Postseason Push</h3>
                <Link to="/playoff">{run ? 'View Bracket' : 'Start Run'}</Link>
            </div>
            <div className="action-row">
                <div>
                    {!run ? (
                        <div className="action-detail">
                            Today's bracket is ready. Battle through AA, AAA, and Playoffs for trophies and packs.
                        </div>
                    ) : null}
                    {run && isChampion ? (
                        <div className="action-detail">Champion! Gold trophy earned. Come back tomorrow.</div>
                    ) : null}
                    {run && isEliminated ? (
                        <div className="action-detail">
                            Eliminated in the {getSeriesAndRound(run.currentRound)}.{trophyInfo ? ` ${trophyInfo.label} earned!` : ' Try again tomorrow!'}
                        </div>
                    ) : null}
                    {run && run.status === GLOBALS.PLAYOFF_STATUS.ACTIVE ? (
                        <div className="action-detail">
                            Next up: <strong>{getSeriesAndRound(run.currentRound)}</strong>
                        </div>
                    ) : null}
                </div>
                {isEliminated ? (
                    <Link to="/playoff" className="card-cta orange">Eliminated</Link>
                ) : null}
                {isChampion ? (
                    <Link to="/playoff" className="card-cta green">Champion</Link>
                ) : null}
                {!isEliminated && !isChampion ? (
                    <Link to="/playoff" className="card-cta orange">{!run ? 'Start' : 'Play'}</Link>
                ) : null}
            </div>
        </div>
    );
};

export default PlayoffPromoCard;
